<form [formGroup]="formGroup">
    <div class="audit-workflow-graph">
        @if (workflowConfig) {
            <cerrix-workflow [config]="workflowConfig"></cerrix-workflow>
        }
    </div>

    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'main.detailsTitle' | t }}</div>
        <div class="detail-page-card-body padded form-group-styling">
            <div class="row">
                <div class="col left-block">
                    <div class="row">
                        <div class="col">
                            <cerrix-textfield
                                [fieldLabel]="'main.auditNameLabel' | t"
                                identifier="auditNameInput"
                                [placeholder]="'main.requiredPlaceholder' | t"
                                formControlName="auditName"
                                dataUiid="audit-name-input"
                            ></cerrix-textfield>
                        </div>
                        <div class="col">
                            <cerrix-textfield
                                [fieldLabel]="'main.auditPlanLabel' | t"
                                identifier="auditPlanInput"
                                formControlName="auditPlan"
                                dataUiid="audit-plan-input"
                            ></cerrix-textfield>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label for="nameInput">{{ 'main.auditTypeLabel' | t }}</label>
                                <cerrix-select
                                    id="auditTypeSelect"
                                    [prettyName]="'main.auditTypePrettyName' | t"
                                    bindValue="ID"
                                    bindLabel="Name"
                                    formControlName="auditType"
                                    [getDataMethod]="standingData.types"
                                    dataUiid="audit-type-select"
                                    [required]="true"
                                    [placeholder]="'main.requiredPlaceholder' | t"
                                >
                                </cerrix-select>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label for="nameInput">{{ 'main.criticalityLabel' | t }}</label>
                                <cerrix-select
                                    id="criticality"
                                    [prettyName]="'main.criticalityPrettyName' | t"
                                    bindValue="ID"
                                    bindLabel="Name"
                                    formControlName="criticality"
                                    [getDataMethod]="standingData.criticalities"
                                    dataUiid="audit-criticality-select"
                                >
                                </cerrix-select>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label for="nameInput">{{ 'main.auditScoreLabel' | t }}</label>
                                <cerrix-select
                                    id="auditScore"
                                    [prettyName]="'main.auditTypePrettyName' | t"
                                    bindValue="ID"
                                    bindLabel="Name"
                                    formControlName="auditScore"
                                    [getDataMethod]="standingData.scores"
                                    dataUiid="audit-score-select"
                                >
                                </cerrix-select>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label for="nameInput">{{ 'main.confidentialityLabel' | t }}</label>
                                <cerrix-select
                                    id="confidentiality"
                                    [prettyName]="'main.confidentialityPrettyName' | t"
                                    bindValue="ID"
                                    bindLabel="Name"
                                    formControlName="confidentiality"
                                    [getDataMethod]="standingData.confidentialities"
                                    dataUiid="audit-confidentiality-select"
                                >
                                </cerrix-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col right-block">
                    <div class="form-group">
                        <label for="nameInput">{{ 'main.sponsorsLabel' | t }}</label>
                        <cerrix-select
                            id="sponsorsSelect"
                            [prettyName]="'main.sponsorsLabel' | t"
                            bindValue="ID"
                            bindLabel="Name"
                            formControlName="sponsors"
                            [getDataMethod]="standingData.sponsorUsers"
                            [multiple]="true"
                            [closeOnSelect]="false"
                            dataUiid="audit-sponsors-select"
                        >
                        </cerrix-select>
                    </div>

                    <div class="form-group">
                        <label for="nameInput">{{ 'main.auditeesLabel' | t }}</label>
                        <cerrix-select
                            id="auditeesSelect"
                            [prettyName]="'main.auditeesLabel' | t"
                            bindValue="ID"
                            bindLabel="Name"
                            formControlName="auditees"
                            [getDataMethod]="standingData.auditeeUsers"
                            [multiple]="true"
                            [closeOnSelect]="false"
                            dataUiid="audit-auditees-select"
                        >
                        </cerrix-select>
                    </div>

                    <div class="form-group">
                        <label for="nameInput">{{ 'main.auditorsLabel' | t }}</label>
                        <cerrix-select
                            id="auditorsSelect"
                            [prettyName]="'main.auditorsLabel' | t"
                            bindValue="ID"
                            bindLabel="Name"
                            formControlName="auditors"
                            [getDataMethod]="standingData.auditorUsers"
                            [multiple]="true"
                            [closeOnSelect]="false"
                            dataUiid="audit-auditors-select"
                        >
                        </cerrix-select>
                    </div>

                    <div class="form-group">
                        <label for="nameInput">{{ 'main.reviewersLabel' | t }}</label>
                        <cerrix-select
                            id="reviewersSelect"
                            [prettyName]="'main.reviewersLabel' | t"
                            bindValue="ID"
                            bindLabel="Name"
                            formControlName="reviewers"
                            [getDataMethod]="standingData.reviewerUsers"
                            [multiple]="true"
                            [closeOnSelect]="false"
                            dataUiid="audit-reviewers-select"
                        >
                        </cerrix-select>
                    </div>

                    <div class="form-group">
                        <label for="nameInput">{{ 'main.chiefAuditExecutivesLabel' | t }}</label>
                        <cerrix-select
                            id="chiefAuditExecutivesSelect"
                            [prettyName]="'main.chiefAuditExecutivesPrettyName' | t"
                            bindValue="ID"
                            bindLabel="Name"
                            formControlName="chiefAuditExecutives"
                            [getDataMethod]="standingData.chiefAuditExecutiveUsers"
                            [multiple]="true"
                            [closeOnSelect]="false"
                            dataUiid="audit-chief-audit-executive-select"
                        >
                        </cerrix-select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col left-block">
                    <cerrix-textarea
                        [fieldLabel]="'main.auditObjectiveLabel' | t"
                        identifier="auditObjectiveInput"
                        formControlName="auditObjective"
                        dataUiid="audit-objective-input"
                    ></cerrix-textarea>
                </div>

                <div class="col right-block">
                    <cerrix-textarea
                        [fieldLabel]="'main.rationaleLabel' | t"
                        identifier="auditRationaleInput"
                        formControlName="auditRationale"
                        dataUiid="audit-rationale-input"
                    ></cerrix-textarea>
                </div>
            </div>

            <cerrix-textarea
                [fieldLabel]="'main.auditConclusionLabel' | t"
                identifier="auditConclusionInput"
                formControlName="auditConclusion"
                dataUiid="audit-conclusion-input"
            ></cerrix-textarea>
        </div>
    </div>
</form>
